import { COOKIE_POLICY_URL, PRIVACY_POLICY_URL } from "../../../config";

export default {
    yesNo: {
        yes: 'Da',
        no: 'Ne'
    },
    error: {
        genericError: 'Došlo je do pogreške. Molimo, pokušajte kasnije.',
        sessionExpired: 'Vaša prijava je istekla. Molimo, prijavite se ponovno.',
        restartApp: 'Ponovno pokrenite aplikaciju',
        networkError: 'Usluga je privremeno nedostupna.',
    },
    months: {
        0: 'Sječanj',
        1: 'Veljača',
        2: 'Ožujak',
        3: 'Travanj',
        4: 'Svibanj',
        5: 'Lipanj',
        6: 'Srpanj',
        7: 'Kolovoz',
        8: 'Rujan',
        9: 'Listopad',
        10: 'Studeni',
        11: 'Prosinac',
    },
    validation: {
        required: 'Ovaj podatak je obavezan',
        email: 'Neispravan format email adrese',
        number: 'Neispravan brojčani unos',
        max: 'Ulaz je predug (maksimum je %{number} znakova)',
        passwordsEqual: 'Nova lozinka ne može biti jednaka staroj',
        passwordsDiffer: 'Lozinke se ne podudaraju',
        maximumAmount:'Najveći dopušteni iznos po nadoplati eNovčanika je 25 EUR',
        minimumAmount:'Minimalni dopušteni iznos po nadoplati eNovčanika je 1 EUR',
        amountRequired: 'Obavezno je odabrati ispravan iznos',
    },
    banners: {
        euFundsTitle: 'Projekt je sufinancirala Europska unija iz Kohezijskog fonda',
        mobileApplicationTitle: 'Mobilna aplikacija daje vam brojne pogodnosti',
        mobileApplicationText: 'Imajte karte i kupone uvijek uz sebe. Kupujte brzo i sigurno te budite informirani o svim promjenama na svojoj ruti.',
        prometSplitTitle: 'Sigurnu i ugodnu vožnju želi vam Promet d.o.o. Split'
    },
    title: 'Autobusne karte',
    price: 'Cijena',
    currencySymbol: 'KN',
    bottomTabHome: 'Početna',
    bottomTabTickets: 'Karte',
    bottomTabBusLines: 'Linije',
    bottomTabMore: 'Profil',
    save: 'Spremi',
    cancel: 'Odustani',
    close: 'Zatvori',
    noResults: 'Nema rezultata',
    downloadInvoice: 'Preuzmi račun',
    downloadDocumentError: 'Dogodila se greška prilikom preuzimanju dokumenta',
    noTransactionsCurrently: 'Trenutno nemate izvršenih transakcija',
    noNotificationsCurrently: 'Trenutno nemate pristigle poruke',
    noActiveCoupons: 'Trenutno nemate važećih kupona',
    periodNameMontly: 'Mjesečni kupon',
    periodNameYearly: 'Godišnji kupon',
    validFrom: 'Vrijedi od',
    to: 'do',
    findOutMore: 'Saznaj više',
    areTermsAcceptedErrorMessage: 'Obavezno je prihvatiti uvjete',
    areTermsOfUseAcceptedErrorMessage: 'Obavezno je prihvatiti opće uvjete i odredbe',
    croatia: 'Hrvatska',
    inactiveCard: 'Kartica je neaktivna',
    cardNotFound: 'Kartica nije pronađena',
    table: {
        itemsPerPage: 'Rezultata po stranici',
        of: 'od'
    },
    navigation: {
        dashboard: 'Nadzorna ploča',
        login: 'Prijava',
        logout: 'Odjava',
        register: 'Registracija',
        forgotPassword: 'Zaboravljena lozinka',
        resetPassword: 'Reset lozinke',
        changePassword: 'Promijeni lozinku',
        myProfile: 'Moj profil'
    },
    leftNavigation: {
        eWallet: "eNovčanik",
        myCoupons: "Moji kuponi",
        myTransactions: "Moje transakcije",
        busLines: "Vozni red",
        routeCalculation: "Izračunaj rutu",
        frequentlyAskedQuestions: "Česta pitanja",
        sellingSpots: "Prodajna mjesta"
    },
    footer: {
        footerText: 'Sva prava pridržana 2022. Promet d.o.o. Split',
        termsOfUse: 'Opći uvjeti i odredbe',
        contact: 'Kontakt'
    },
    contact: {
        title: 'Kontakt',
        infoText: 'Društvo s ograničenom odgovornošću za obavljanje komunalne djelatnosti prijevoza putnika u javnom prometu',
        address: 'Adresa',
        oib: 'OIB',
        mb: 'MB',
        freeInfoTelephone: 'Info telefon',
        webAddress: 'Web adresa',
        emailAddress: 'Email adresa'
    },
    termsOfUse: {
        title: 'Opći uvjeti i odredbe'
    },
    routeCalculation: {
        title: 'Izračunaj rutu'
    },
    frequentlyAskedQuestions: {
        title: 'Česta pitanja'
    },
    sellingSpots: {
        title: 'Prodajna mjesta',
        showOnMapButton: 'Pokaži na karti'
    },
    busLines: {
        title: 'Vozni red'
    },
    verifyActivationMail: {
        title: 'Verifikacija korisničkog računa',
        success: 'Super! Hvala vam na registraciji, sve je spremno za lako i brzo korištenje web portala. Hvala i sretan put.'
    },
    dashboard: {
        title: 'Dobrodošli',
        accountStateTitle: 'Stanje vašeg računa',
        topUpText: 'Želite nadoplatiti',
        topUpInfoText: 'Napomena: Maksimalni iznos eNovčanika ne smije biti veći od {{primaryAmount}} {{primarySign}} ({{secondaryAmount}} {{secondarySign}}). <b>eNovčanik služi za kupovinu pojedinačnih karata. Personalizirane karte nije moguće kupiti putem eNovčanika.</b>',
        topUpButtonText: 'Nadoplati odmah',
        activateFullAccountTitle: 'Aktiviraj puni profil',
        activateFullAccountText1: 'Postani personalizirani korisnik Promet d.o.o. Split i otkrij dodatne mogućnosti. Samo korisnik punog profila može kupovati mjesečne i godišnje kupone.',
        activateFullAccountText2: 'Kako do punog profila ako si:',
        activateFullAccountText2Alt: 'Ako posjeduješ fizičku personaliziranu karticu ili već imaš aktivacijski kôd nastavi na aktivaciju.',
        activateFullAccountSelectText: 'Odaberite svoj status',
        activateFullAccountButtonText: 'Nastavi na aktivaciju',
        activeCouponsTitle: 'Moji kuponi',
        latestTransactionsTitle: 'Posljednje transakcije',
        messagesAndNotificationsTitle: 'Poruke i obavijesti',
        buyCoupon: 'Kupi kupon'
    },
    activateFullProfile: {
        title: 'Postani personalizirani korisnik',
        subtitle: 'Aktiviraj puni profil',
        explanation: 'Korisnik Promet mora se odlučiti želi li koristiti fizičku karticu ili mobilnu aplikaciju. Nije moguće istovremeno koristiti oba spomenuta medija.',
        activateButton: 'Aktiviraj',
        activationCodePlaceholder: 'Aktivacijski kôd',
        cardNumberPlaceholder: 'Broj kartice',
        oibPlaceholder: 'OIB',
        chooseMedium: 'Odaberi medij',
        selectOptions: {
            physical: 'Personalizirana fizička kartica',
            mobile: 'Mobilna aplikacija'
        },
        infoPhysical: 'Za korištenje punog profila upišite broj kartice i OIB',
        infoMobile: 'Za korištenje punog profila upišite aktivacijski kôd',
        agreement: 'Prihvaćam uvjete',
        processStartedSuccessMessage: 'Aktivacija punog profila je uspješno pokrenuta',
        processStarted: 'Aktivacija punog profila je pokrenuta'
    },
    myProfile: {
        title: 'Moj račun',
        tabs: {
            myProfile: {
                title: 'Moj profil',
                form: {
                    firstName: 'Ime:',
                    lastName: 'Prezime:',
                    email: 'Email:'
                },
                cardInfo: {
                    cardNumber: 'Broj personalizirane kartice:',
                    profile: 'Naziv profila:',
                    status: 'Status kartice:'
                },
                profiles: {
                    refreshProfiles: "Osvježi profile",
                    info: "Osvježite korisničke profile uz provjeru pripadnosti učeničkom ili studentskom profilu.",
                    processStarted: "Proces je započet, biti će te obaviješteni po njegovom završetku."
                }
            },
            personalData: {
                title: 'Osobni podaci',
                form: {
                    firstName: 'Ime:',
                    lastName: 'Prezime:',
                    oib: 'OIB:',
                    dateOfBirth: 'Datum rođenja:',
                    address: 'Adresa:',
                    postCode: 'Broj pošte:',
                    houseNumber: 'Kućni broj:',
                    administrativeArea: 'Mjesto:'
                }
            },
            changePassword: {
                title: 'Promjena lozinke',
                button: 'Promijeni lozinku',
                form: {
                    oldPassword: 'Stara lozinka:',
                    newPassword: 'Nova lozinka:',
                    confirmPassword: 'Potvrdi lozinku:'
                }
            }
        },
        changePasswordSuccess: 'Lozinka je promijenjena',
        updateUserSuccess: 'Profil je uspješno ažuriran',
        updateUserSuccessWithMail: 'Profil uspješno ažuriran, poslali smo vam link za verifikaciju na \n{{email}}',
    },
    myTransactions: {
        title: 'Moje transakcije'
    },
    myCoupons: {
        title: 'Moji kuponi'
    },
    cardStates: {
        active: 'Aktivna',
        inactive: 'Neaktivna'
    },
    tickets: {
        details: {
            title: 'Detalji karte',
            alsoWorth: 'Vrijedi i za',
            worthForPeriod: 'Vrijedi za period',
            userId: 'ID korisnika',
            subsidy: 'Subvencija',
            discount: 'Popust',
            numberOfTrips: {
                title: 'Broj putovanja',
                unlimited: 'Neograničen'
            },
            couponType: {
                monthly: 'Mjesečni kupon',
                yearly: 'Godišnji kupon'
            }
        },
        ticketList: {
            until: 'još',
        },
        ticketFullView: {
            userPictureModalClose: 'Zatvori sliku',
            activationModalClose: 'Uredu',
            notActiveCouponTicket: 'Kupon još nije aktivan',
            details: 'Detalji',
            showBusOnMap: 'Prikaži autobus na karti',
            busTransfers: 'Presjedanja',
            latestRegisteredRide: 'Zadnja registrirana vožnja',
            enterTime: 'Vrijeme ulaska',
            stationName: 'Stanica',
            busLine: 'Linija',
            bus: 'Oznaka autobusa',
            topBarText: {
                used: 'Iskorištena karta',
                inactive: 'Kupljena karta',
                active: 'Aktivna karta',
            },
        },
        activeAndPurchasedTicketsButtonText: 'Aktivirane i kupljene karte',
        usedTicketsButtonText: 'Prikaži iskorištene karte',
        noUsedTicketsMessage: 'Nemate iskorištenih karata',
        noTicketsMessage: 'Nemate aktivnih ili kupljenih karata',
        usedTickets: 'Iskorištene karte',
        activeTickets: 'Aktivirane karte',
        purchasedTickets: 'Kupljene karte',
        activateTicket: 'Skeniraj QR kod za aktivaciju',
        ticketIsValid: 'Vrijedi do',
        expiredTicket: 'Vaša karta je istekla',
        usedTicket: 'Ova karta je istekla',
        ticketType: 'Tip karte',
        ticketNumber: 'Broj karte',
        areaCoverage: 'Vrijedi za',
        purchaseDate: 'Datum kupnje',
        activatedDate: 'Datum aktivacije',
        expiredDate: 'Datum isteka',
        validUntilDate: 'Vrijedi do datuma',
        validCoupons: 'Važeći kuponi',
        ticketDuration: 'Trajanje karte',
        fromActivation: 'od aktivacije',
        scanMessage: 'Skenirajte kartu prilikom svakog ulaska u autobus.',
        usedTicketMessage: 'Ova karta iskorištena.',
        notEligibleToPurchaseTheCoupon: 'Nemate pravo na kupnju kupona.',
        activeTicketMessage: 'Ova karta je aktivna. Skenirajte kartu prilikom svakog ulaska u autobus.',
        fullViewTicketScreenTopBarTitle: 'Aktivna karta',
        activation: {
            activated: 'Vaša karta je aktivirana',
            expired: 'Karta je istekla',
            valid: 'Vaša karta je validirana',
            detailsTitle: {
                enterTime: 'Vrijeme ulaska',
                busStation: 'Stanica',
                busLine: 'Linija',
                busNumber: 'Autobus',
            },
        },
        buyTicket: 'Kupi kartu',
        buyCoupon: 'Kupi kupon',
        searchButton: 'Prikaži',
        anotherCouponButton: 'Želim drugi kupon',
        buyMessage: 'Odaberite vrstu karte koju želite kupiti',
        buy: {
            buyTicketOrCoupon: 'Kupnja kupona',
            haveSubsidy: 'Imate subvenciju za kupovinu kupona!',
            availableSubsidyCoupons: 'Imate subvenciju za sljedeće kupone',
            showSubsidisedCoupons: 'Prikaži kupone',
            successScreenMain: 'Uspješno kupljeno',
            successScreenSub: 'Ne zaboravi aktivirati kartu prilikom ulaska u autobus. Tek će tada postati važeća.',
            errorScreen: 'Greška prilikom kupovine, molimo pokušajte ponovno...',
            loadingScreen: 'Izvšavam kupovinu, molimo pričekajte...',
            for: 'za',
            buyFor: 'Kupi za',
            buySingleTicket: 'Pojedinačna karta',
            buyDailyTicket: 'Dnevna karta',
            buyCouponTicket: 'Kupon',
            singleTicket: 'Pojedinačna karta',
            dailyTicket: 'Dnevna karta',
            multiDayTicket: 'Višednevna karta',
            couponTicket: 'Kupon',
            childTicket: 'Dječja karta',
            day: 'dan',
            days: 'dana',
            selectTicketDuration: 'Odaberi vrijeme trajanja',
            selectTicketValidArea: 'Odaberi područje putovanja',
            mapViewModalTitle: 'Područje valjanosti karte',
            warning: 'Upozorenje!',
            dateWarningDescription: "Odabrani kupon istječe za %{days} dan(a). Jeste li sigurni da ga želite kupiti?",
            overlapWarningDescription: "Kupon koji želite kupiti preklapa se sa već važećim kuponom. Želite li ipak kupiti odabrani kupon?",
        },
        ribbonTicketPurchase: 'Kupljena karta vrijedi samo za putovanje unutar označene zone',
        addGoal: 'Dodaj odredište',
        selectPlaceholder: 'Odaberi područje',
        fromPlaceholder: 'Polazišno područje',
        toPlaceholder: 'Odredišno područje',
        duration: 'Trajanje: ',
        validFor: 'Vrijedi za: ',
        allLocations: 'sve relacije',
        iWantChildTicket: 'Želim dječju kartu (6-10 god)',
        totalPrice: 'Ukupna cijena',
        noMoneyError: 'Raspoloživo stanje je nedovoljno za kupovinu. Nadoplati prepaid račun.',
        balance: 'Stanje eNovčanika',
        validMinutes: 'min',
        continueButtonText: 'Nastavi',
        trafficAreaAll: 'Cijelo prometno područje',
    },
    login: {
        title: 'Dobrodošli',
        loginToPrometPortal: 'Prijava u Promet portal',
        button: 'Prijavi se',
        forgotPassword: 'Zaboravljena lozinka',
        success: 'Uspješna prijava',
        form: {
            email: 'Email adresa',
            password: 'Lozinka',
        },
        info: {
            eWallet: "Nadoplati eNovčanik",
            penalty: "Platite obavijest o prekršaju",
            busLines: "Vozni red",
            routeCalculation: "Izračunaj rutu",
            frequentlyAskedQuestions: "Česta pitanja",
            sellingSpots: "Prodajna mjesta"
        },
        noAccount: {
            question: 'Nemate korisnički račun?',
            action: 'Registriraj se'
        }
    },
    logout: {
        success: 'Uspješno ste se odjavili'
    },
    loginVerification: {
        title: 'Verifikacija računa',
        button: 'Pošalji novi email',
        success: 'Račun je verificiran',
        form: {
            email: 'Email adresa',
        },
    },
    register: {
        title: 'Dobrodošli',
        register: "Registracija",
        button: 'Registriraj se',
        successTitle: 'Registracija uspješna',
        successText: 'Vaš račun je kreiran! Poslan vam je link za njegovu aktivaciju na {{email}}. Nakon potvrde vaš račun bit će aktiviran.',
        form: {
            firstName: 'Ime',
            lastName: 'Prezime',
            email: 'E-mail adresa',
            password: 'Lozinka',
            passwordConfirm: 'Ponovi lozinku',
            termsOfUseAccept: 'Prihvaćam opće uvjete i odredbe',
            areTermsOfUseAcceptedErrorMessage: 'Obavezno je prihvatiti opće uvjete i odredbe'
        }
    },
    forgotPassword: {
        title: 'Zaboravljena lozinka',
        text: 'Link za obnovu lozinke poslan!',
        description: 'Poslali smo vam link na \n<b>{{email}}</b>',
        button: 'Pošalji potvrdu',
        form: {
            email: 'E-mail adresa',
        },
    },
    resetPassword: {
        title: 'Postavi novu lozinku',
        button: 'Promijeni lozinku',
        success: 'Lozinka je uspješno postavljena',
        form: {
            password: 'Nova lozinku',
            confirmPassword: 'Potvrdi lozinku'
        },
    },
    eWallet: {
        title: 'Nadoplati eNovčanik',
        cardNumberLabel: 'Upišite broj kartice za koju želite nadoplatiti sredstva:',
        cardNumber: 'Broj kartice',
        emailLabel: 'Upišite email adresu za dostavu računa:',
        email: 'Email',
        amountLabel: 'Odaberite iznos koji želite nadoplatiti:',
        selectedAmount: 'Odabrali ste iznos:',
        termsOfUseLabel: 'Prihvaćam uvjete korištenja',
        accountEWalletAmount: 'Trenutno stanje eNovčanika:',
        topUpInfoText: 'Napomena: Maksimalni iznos eNovčanika ne smije biti veći od {{primaryAmount}} {{primarySign}} ({{secondaryAmount}} {{secondarySign}}).',
        topUp: 'Nadoplati',
        checkCardEWalletTitle: 'Provjeri stanje eNovčanika',
        checkCardEWalletLabel: 'Upišite broj kartice za provjeru aktualnog stanja',
        checkCardEWallet: 'Provjeri stanje'
    },
    penaltyPay: {
        title: 'Platite obavijest o prekršaju',
        penaltyNumberLabel: 'Upišite broj prekršaja koji želite platiti',
        penaltyNumber: 'Broj prekršaja',
        getPenalty: 'Prikaži prekršaj',
        penaltyDetailsTitle: 'Detalji prekršaja',
        issuedAt: 'Vrijeme izdavanja',
        stationIssuedAt: 'Stanica izdavanja',
        stopName: 'Stajalište',
        routeName: 'Linija',
        amount: 'Iznos',
        description: 'Opis',
        emailLabel: 'Upišite email adresu za dostavu računa:',
        email: 'Email',
        penaltyGetError: 'Greška prilikom dohvata prekršaja, molimo provjerite broj prekršaja i pokušajte ponovno',
        termsOfUseLabel: 'Prihvaćam uvjete korištenja',
        topUp: 'Plati',
        pay: 'Plati',
        info: {
            title: 'Plaćanje obavijesti o prekršaju',
            successText: 'Transakcija je provedana i biti će obrađena unutar 15 minuta. Obavijestiti ćemo Vas na email gdje će te dobiti i račun kao potvrdu plaćanja. Ukoliko se dogodi problem sredstva će biti vraćena.',
            cancelText: 'Transakcija je prekinuta.',
            errorText: 'Došlo je do pogreške prilikom provedbe plaćanja obavijesti o prekršaju. Molimo, pokušajte kasnije.',
            returnToHome: 'Početna stranica',
            tryAgain: 'Pokušajte ponovno'   
        }
    },
    eWalletTopUpInfo: {
        title: 'Nadoplati eNovčanik',
        successText: 'Transakcija je provedena i bit će obrađena unutar 15 minuta. Obavijestit ćemo Vas na email nakon čega će se iznos pojaviti na eNovčaniku. Ukoliko se dogodi problem sredstva će biti vraćena.',
        cancelText: 'Transakcija je prekinuta.',
        errorText: 'Došlo je do pogreške prilikom nadoplate eNovčanika. Molimo, pokušajte kasnije.',
        returnToHome: 'Početna stranica',
        tryAgain: 'Pokušajte ponovno'
    },
    purchaseCouponInfo: {
        title: 'Kupovina kupona',
        successText: 'Transakcija je provedena i bit će obrađena unutar 15 minuta. Obavijestit ćemo Vas na email nakon čega će se kupon pojaviti na listi kupona. Ukoliko se dogodi problem sredstva će biti vraćena.',
        cancelText: 'Transakcija je prekinuta.',
        errorText: 'Došlo je do pogreške prilikom kupovine kupona. Molimo, pokušajte kasnije.',
        returnToHome: 'Početna stranica',
        tryAgain: 'Pokušajte ponovno'
    },
    euro:{
        rate: 'Tečaj: 1 EUR = 7,53450 HRK',
    },
    cookies:{
        consentModal: {
            title: 'Ova stranica koristi kolačiće',
            description: `Koristimo kolačiće za osiguranje ispravnog funkcioniranja aplikacije. Ne prikupljamo nikakve informacije o Vašem korištenju aplikacije. Kako bi saznali više o korištenju Vaših podataka posjetite pravilnik o postupanju s kolačićima i/ili izjavu o privatnosti. <br/><a class="cc-link" href="${COOKIE_POLICY_URL.hr}">Pravilnik o postupanju s "kolačićima"</a><br/><a class="cc-link" href="${PRIVACY_POLICY_URL.hr}">Izjava o privatnosti</a>`,
            acceptAllBtn: 'Prihvaćam sve',
            rejectAllBtn: 'Odbijam sve',
            showPreferencesBtn: 'Upravljaj postavkama',
        },
        preferencesModal: {
            title: 'Postavke kolačića',
            acceptAllBtn: 'Prihvaćam sve',
            acceptNecessaryBtn: 'Odbijam sve osim nužnih',
            savePreferencesBtn: 'Spremi postavke',
            closeIconLabel: 'Zatvori',
            sections: [
                {
                    title: 'Korištenje kolačića',
                    description: `Koristimo kolačiće za osiguranje ispravnog funkcioniranja aplikacije. Ne prikupljamo nikakve informacije o Vašem korištenju aplikacije. Kako bi saznali više o korištenju Vaših podataka posjetite pravilnik o postupanju s kolačićima i/ili izjavu o privatnosti.<br/><a class="cc-link" href="${COOKIE_POLICY_URL.hr}">Pravilnik o postupanju s "kolačićima"</a><br/><a class="cc-link" href="${PRIVACY_POLICY_URL.hr}">Izjava o privatnosti</a>`
                },
                {
                    title: 'Strogo potrebni kolačići',
                    description: 'Ovi kolačići su neophodni za ispravno funkcioniranje web stranice. Bez ovih kolačića web stranica ne bi radila ispravno.',
                    linkedCategory: 'necessary'
                }
            ]
        }
    }
};
